#!/usr/bin/env node
/**
 * HoloScript MCP Server CLI
 *
 * Starts the MCP server for AI agent integration.
 */

import './index';
